/**
 * THIS FILE WILL WORK AS THE START UP FILE FOR THE APPLICATION
 * THIS WILL CONTAIN THE HEADER AND FOOTER AND COMMON ROUTE IMPORT
 */
import React from 'react';
import RoutesSetup from 'LIBRARY/Routes/Routes';
import { Route } from 'react-router-dom';

class App extends React.Component{
  render() {
    return (
      <div className="App">
        <RoutesSetup />
      </div>
    );
  }
  
}

export default App;
